export const DELIVERY_ORDER_STATUS = {
  UNCONFIRMED: "UNCONFIRMED",
  GENERATED: "GENERATED",
  ACCEPTED: "ACCEPTED",
  READY: "READY",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
};
